import React from 'react';

import { useDataAttributes } from '@lumapps/data-attributes';
import { Menu } from '@lumapps/lumx-menu/components/Menu';
import { mdiAccountMultiple } from '@lumapps/lumx/icons';
import { useSelector } from '@lumapps/redux/react';
import { Link as RouterLink } from '@lumapps/router';
import { canAccessSegmentAdmin } from '@lumapps/segment/ducks/slice/selectors';
import { useTranslate } from '@lumapps/translations';

import { SEGMENT_ADMIN } from '../../keys';
import { segmentBaseRoute } from '../../routes';

export interface SegmentSettingMenuProps {
    scope: string;
}

export const SegmentSettingMenu: React.FC<SegmentSettingMenuProps> = ({ scope }) => {
    const { get } = useDataAttributes(scope);

    const canAccessSegment = useSelector(canAccessSegmentAdmin);
    const { translateKey } = useTranslate();

    if (!canAccessSegment) {
        return null;
    }

    return (
        <Menu.Item
            icon={mdiAccountMultiple}
            as={RouterLink}
            to={segmentBaseRoute}
            {...get({ element: 'access-segments' })}
        >
            {translateKey(SEGMENT_ADMIN.SEGMENT_SIDE_NAV_TITLE)}
        </Menu.Item>
    );
};

SegmentSettingMenu.displayName = 'SegmentSettingMenu';
